import { render } from "./deliveryInfo.vue?vue&type=template&id=6cf0c640"
import script from "./deliveryInfo.vue?vue&type=script&lang=js"
export * from "./deliveryInfo.vue?vue&type=script&lang=js"

import "./deliveryInfo.vue?vue&type=style&index=0&id=6cf0c640&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__